import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FeatureInfoComponent } from '@principle-theorem/ng-feature-flags';
import {
  ContentContainerComponent,
  CurrentBrandScope,
  InformationBoxComponent,
  OrganisationService,
} from '@principle-theorem/ng-principle-shared';
import {
  BreadcrumbsComponent,
  type IBreadcrumb,
} from '@principle-theorem/ng-shared';
import { type IBrand } from '@principle-theorem/principle-core/interfaces';
import { filterUndefined, type WithRef } from '@principle-theorem/shared';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AllocationSettingsComponent } from './allocation-settings/allocation-settings.component';
import { InvoiceDueDateSettingsComponent } from './invoice-due-date-settings/invoice-due-date-settings.component';
import { ManualTransactionTypesComponent } from './manual-transaction-types/manual-transaction-types.component';
import { PaymentMethodAvailabilityComponent } from './payment-method-availability/payment-method-availability.component';
import { PractitionerIncomeSettingsComponent } from './practitioner-income-settings/practitioner-income-settings.component';

@Component({
  selector: 'pr-accounting',
  templateUrl: './accounting.component.html',
  styleUrls: ['./accounting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FeatureInfoComponent,
    BreadcrumbsComponent,
    ContentContainerComponent,
    ManualTransactionTypesComponent,
    AllocationSettingsComponent,
    InvoiceDueDateSettingsComponent,
    InformationBoxComponent,
    PaymentMethodAvailabilityComponent,
    PractitionerIncomeSettingsComponent,
  ],
})
export class AccountingComponent {
  readonly organisation = inject(OrganisationService);
  brand$: Observable<WithRef<IBrand>>;
  breadcrumbs$: Observable<IBreadcrumb[]>;

  constructor(currentBrand: CurrentBrandScope) {
    this.brand$ = currentBrand.doc$.pipe(filterUndefined());
    this.breadcrumbs$ = this.brand$.pipe(
      map((brand) => [
        { label: 'Settings', path: '../../../' },
        { label: brand.name },
        { label: 'Accounting' },
      ])
    );
  }
}
